import { Component, HostBinding, Input } from '@angular/core'
import { ThemePalette } from '@angular/material/core'

@Component({
  selector: 'lin-table-message',
  template: '<ng-content></ng-content>',
  styles: [
    `
      :host {
        display: block;
        padding: 20px;
        text-align: center;
        font-size: 1.25em;
      }

      :host(.warn) {
        color: var(--red-500-color);
      }
    `,
  ],
  standalone: false,
})
export class TableMessageComponent {
  @Input() color: ThemePalette

  @HostBinding('class') get className() {
    return this.color
  }
}
